// src/catalog/components/detail/CatalogEntryMetadataPanel.jsx

export default function CatalogEntryMetadataPanel({
  title = "Metadata",
  rows = []
}) {
  const visibleRows = rows.filter(
    (row) => row?.label && row?.value
  );

  if (visibleRows.length === 0) {
    return null;
  }

  return (
    <div className="catalog-detail__panel">
      <h2>{title}</h2>

      <dl>
        {visibleRows.map((row) => (
          <div key={row.label}>
            <dt>{row.label}</dt>
            <dd>{row.value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
